import { render } from "./TeikiTerms.vue?vue&type=template&id=081cde0e&scoped=true"
import script from "./TeikiTerms.vue?vue&type=script&lang=js"
export * from "./TeikiTerms.vue?vue&type=script&lang=js"

import "./TeikiTerms.vue?vue&type=style&index=0&id=081cde0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081cde0e"]])

export default __exports__